import { ResourcesConfig } from 'aws-amplify';

const isLocalhost = window.location.hostname === 'localhost';
const redirectUrl = isLocalhost
  ? 'http://localhost:3002'
  : 'https://ea-qa.sae-g.com';

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'ap-northeast-1_qjgrtbzGz',
      userPoolClientId: '7p66bm72dqp5tqf2fi9mamgrvi',
      loginWith: {
        oauth: {
          domain: 'ea-guide-viewer-20251224125510.auth.ap-northeast-1.amazoncognito.com',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [redirectUrl],
          redirectSignOut: [redirectUrl],
          responseType: 'code',
        },
      },
    },
  },
};

export default amplifyConfig;
